import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'


Vue.config.productionTip = false
Vue.use(Router)
Vue.use(ElementUI)
Vue.prototype.$http=axios
Vue.prototype.request = function(method,path,data,callback,config){
  var _this = this;
  let urlPrefix = "/uread/api/v1";
  if(data == true){
      _this.fullscreenLoading = false;
  }else{
      _this.fullscreenLoading = true;
  }
  let success = function (value) {
    _this.fullscreenLoading = false;
        var data = value.data;
        if(data.code != "000000"){
        _this.$alert(data.msg, '提示');
        }else{
            callback && callback(data.data)
        }
    } 
    let fail = function (err) {
        _this.fullscreenLoading = false;
        let status = err.response.status;
        let msg = err.response.data.message;
        if(status == 401){
            localStorage.removeItem("stoken");
            _this.$router.replace({name:"login"});
            _this.$message(msg);
            return ;
        }
        
        _this.$alert("["+status+"]"+msg);
        _this.fullscreenLoading = false;
    };
    if(path.indexOf("login") == -1){
        let stoken = localStorage.getItem("stoken");
        if(stoken == undefined){
            _this.$router.replace({name:"login"});
        }else{
            this.$http.defaults.headers['X-Authorization'] = 'Bearer '+localStorage.getItem("stoken");
        }
      }
  switch (method) {
      case "GET" : {
          this.$http.get(urlPrefix+path,data,config).then(success,fail);break;
      }
      case "POST" : {
          this.$http.post(urlPrefix+path,data,config).then(success,fail);break;
      }
      case "PUT" : {
          this.$http.put(urlPrefix+path,data,config).then(success,fail);break;
      }
      case "DELETE" : {
          this.$http.delete(urlPrefix+path,config).then(success,fail);break;
      }
  }
}
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
